import { apiClient } from '@/shared/services/client'
import type {
  ConfiguracionAnalyticsOdf,
  ConfiguracionAnalyticsOdfUpdateInput,
  ContenidoAnalyticsOdf,
  FiltrosReporteOdf,
  MedicosAnalyticsOdf,
  OverviewAnalyticsOdf,
  TestConnectionInput,
  TestConnectionResult,
} from '../types'

const CONFIG_URL = '/analytics-odf/config'
const REPORTES_URL = '/analytics-odf/reportes'

/** Convierte un objeto de filtros en params de axios, omitiendo los undefined. */
function toParams(filtros?: FiltrosReporteOdf): Record<string, string> | undefined {
  if (!filtros) return undefined
  return Object.fromEntries(
    Object.entries(filtros).filter(([, v]) => v !== undefined),
  ) as Record<string, string>
}

export const analyticsOdfApi = {
  getConfiguracion: async () => {
    const { data } = await apiClient.get<ConfiguracionAnalyticsOdf>(`${CONFIG_URL}/`)
    return data
  },

  saveConfiguracion: async (payload: ConfiguracionAnalyticsOdfUpdateInput) => {
    const { data } = await apiClient.put<ConfiguracionAnalyticsOdf>(`${CONFIG_URL}/`, payload)
    return data
  },

  testConnection: async (payload?: TestConnectionInput) => {
    const { data } = await apiClient.post<TestConnectionResult>(
      `${CONFIG_URL}/test-connection`,
      payload ?? {},
    )
    return data
  },

  getOverview: async (filtros?: FiltrosReporteOdf) => {
    const { data } = await apiClient.get<OverviewAnalyticsOdf>(`${REPORTES_URL}/overview`, {
      params: toParams(filtros),
    })
    return data
  },

  getMedicos: async (filtros?: FiltrosReporteOdf) => {
    const { data } = await apiClient.get<MedicosAnalyticsOdf>(`${REPORTES_URL}/medicos`, {
      params: toParams(filtros),
    })
    return data
  },

  getContenido: async (filtros?: FiltrosReporteOdf) => {
    const { data } = await apiClient.get<ContenidoAnalyticsOdf[]>(`${REPORTES_URL}/contenido`, {
      params: toParams(filtros),
    })
    return data
  },
}
